export default "1ce3dd90db01aa6f.svg"